var _path, _path2, _path3, _path4, _path5, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSupport = function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 51.223v-17c1.667-.666 5.7-2.3 8.5-3.5 2.8-1.2 6.833-.5 8.5 0 5.167 2.334 16 7.3 18 8.5 2.5 1.5 1 3.777.5 4-.457.204-2 .5-2 1 0 .4 1.657.5 4 0l12-5c1.333-.666 4.2-1.4 5 1 .8 2.4-1 4-2 4.5-5 3-15.3 9.1-16.5 9.5-1.5.5-3.5 2.5-13.5-3s-13-4-15.5-3.5c-2 .4-5.5 2.5-7 3.5z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 32.723a7.5 7.5 0 100-15 7.5 7.5 0 000 15zm0-3.5a4 4 0 100-8 4 4 0 000 8z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 17.723l.5 1.5M51.049 17.723l-.597 1.464M55.3 22.2l-1.496.511M54.964 28.322l-1.424-.688M51 32.523l-.464-1.511M44.861 32.322l.678-1.428M41 28.338l1.456-.616M40.5 22.084l1.43.674",
    stroke: "#fff",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.31 24.485c5.42-2.683 7.637-9.252 4.954-14.672C33.58 4.393 27.01 2.176 21.59 4.86c-5.42 2.683-7.637 9.252-4.954 14.672 2.684 5.42 9.253 7.637 14.673 4.953zm-2.268-4.579A5.84 5.84 0 1023.86 9.44a5.84 5.84 0 005.183 10.467z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.047l1.626 1.639M25.58 3.223l.167 2.302M34.043 5.986l-1.626 1.64M38 14.217l-2.308.022M35.105 22.281l-1.585-1.677M26.943 25.996l-.039-2.308M19.31 23.283l1.507-1.75M15 15.426l2.308-.046",
    stroke: "#fff",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 14.723,
    r: 2,
    fill: "#fff"
  })));
};
export default SvgSupport;